import { useMemo } from 'react';

/**
 * Custom hook to check meal availability based on current time
 * @param {string} selectedDate - The selected delivery date in YYYY-MM-DD format
 * @returns {object} - Object with lunchAvailable and dinnerAvailable boolean flags
 */
export const useMealAvailability = (selectedDate) => {
  return useMemo(() => {
    // If no date is selected or it's not today, both meals are available
    if (!selectedDate) {
      return {
        lunchAvailable: true,
        dinnerAvailable: true
      };
    }

    const today = new Date();
    const todayString = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;

    // If selected date is not today, both meals are available
    if (selectedDate !== todayString) {
      return {
        lunchAvailable: true,
        dinnerAvailable: true
      };
    }

    // If selected date is today, apply time-based restrictions
    const now = new Date();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const totalMinutes = hours * 60 + minutes;

    // Lunch disabled: After 11:30 AM (690 minutes) for the rest of the day
    const lunchDisabledStart = 11 * 60 + 30; // 11:30 AM = 690 minutes
    const lunchDisabled = totalMinutes >= lunchDisabledStart;

    // Dinner disabled: After 5:00 PM (1035 minutes) for the rest of the day
    const dinnerDisabledStart = 17 * 60; // 5:00 PM = 1020 minutes
    const dinnerDisabled = totalMinutes >= dinnerDisabledStart;

    return {
      lunchAvailable: !lunchDisabled,
      dinnerAvailable: !dinnerDisabled
    };
  }, [selectedDate]);
};
